export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "from_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desde"])},
          "to_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasta"])},
          "filter": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])},
          "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limpiar"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total de visitas"])},
          "show_crop_field_markers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrar campos"])},
          "tech_visits": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Visitas"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campos"])},
          "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
          "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])}
        }
      }
    }
  })
}